<div *ngIf="deals?.length > 0">
	<div class="title">
		{{ Loc(LocalizedTextIds.CompanyDetailsDeals) }}
	</div>
	<table>
		<tr>
			<th>{{ Loc(LocalizedTextIds.CompanyDetailsOrganization) }}</th>
			<th class="currencycolumn">
				{{ Loc(LocalizedTextIds.CompanyDetailsAmount) }}
			</th>
			<!-- Don't include currency in header, since there can be a mix of currencies -->
			<th>{{ Loc(LocalizedTextIds.CompanyDetailsAnnouced) }}</th>
			<th>{{ Loc(LocalizedTextIds.CompanyDetailsType) }}</th>
			<th *ngIf="showConfidentialStatus" class="confidentialcolumn">
				{{ Loc(LocalizedTextIds.CompanyDetailsConfidential) }}
			</th>
		</tr>
		<tr *ngFor="let item of filteredDeals">
			<td>{{ item.dealParty }}</td>
			<td class="currencycolumn">
				<!-- Note that this will be substituted for N/A on the server-side for J&J Deals -->
				<span
					*ngIf="
						IsNumberOrNumberString(item.amount);
						else dealAmountNotANumber
					"
					>{{
						item.amount
							| currency
								: item.amountCurrency
								: 'symbol-narrow'
								: '1.0-0'
					}}
					{{ item.amountCurrency }}</span
				>
				<ng-template #dealAmountNotANumber>
					{{ item.amount }}
				</ng-template>
			</td>
			<td>{{ item.announcementDate | date: 'mediumDate' : 'GMT' }}</td>
			<td>{{ LocDbValue(item.dealType) }}</td>
			<td *ngIf="showConfidentialStatus" class="confidentialcolumn">
				<div *ngIf="item.isConfidential">
					{{ Loc(LocalizedTextIds.Yes) }}
				</div>
				<div *ngIf="!item.isConfidential">
					{{ Loc(LocalizedTextIds.No) }}
				</div>
			</td>
		</tr>
	</table>
</div>
